(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@ecomplus/client"), require("@ecomplus/utils"), require("eventemitter3"));
	else if(typeof define === 'function' && define.amd)
		define(["@ecomplus/client", "@ecomplus/utils", "eventemitter3"], factory);
	else if(typeof exports === 'object')
		exports["ecomPassport"] = factory(require("@ecomplus/client"), require("@ecomplus/utils"), require("eventemitter3"));
	else
		root["ecomPassport"] = factory(root["@ecomplus/client"], root["@ecomplus/utils"], root["eventemitter3"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__17__, __WEBPACK_EXTERNAL_MODULE__53__, __WEBPACK_EXTERNAL_MODULE__130__) {
return 